import React, { useEffect, useState } from "react";
import { Table, Button, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const { Title } = Typography;

function ManageTasks() {

  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {

      const token = localStorage.getItem("access-token");

      const resp = await axios.get(
        "https://rhrmapi.up2dateinc.com/api/manage-tasks",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setProjects(Array.isArray(resp.data.data) ? resp.data.data : []);

    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "SL No",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
    },
    {
      title: "Client Name",
      dataIndex: "client",
    },
    {
      title: "Project Lead",
      dataIndex: "projectLead",
    },
    {
      title: "Approximate Tasks",
      dataIndex: "tasks",
    },
    {
      title: "Project Duration",
      dataIndex: "duration",
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>

          <Button
            type="primary"
            onClick={() =>
              navigate(`/admin/backlogs/${record._id}`)
            }
          >
            All Tasks
          </Button>

          <Button
            onClick={() =>
              navigate(`/admin/sprints/${record._id}`)
            }
          >
            Sprints
          </Button>

        </Space>
      ),
    },
  ];

  return (
    <div>

      <Title level={3}>Manage Tasks</Title>

      <Table
        columns={columns}
        dataSource={Array.isArray(projects) ? projects : []}
        rowKey="_id"
      />

    </div>
  );
}

export default ManageTasks;